/* models/widgets/tables/main.js */ function _(require, module, exports) {
    const Tables = require(413) /* ./index */;
    exports.Tables = Tables;
    const base_1 = require(6) /* ../../../base */;
    base_1.register_models(Tables);
}
